/**
 * Возвращает отформатированное значение <часы>:<минуты> из
 * числа часов с десятичной частью (13.93).
 */
export default function formatHours(hours) {
  if ('number' !== typeof hours) {
    return hours;
  }
  if (hours < 0) {
    throw new Error('Logic exception: hours < 0');
  }
  
  let hh = Math.trunc(hours);
  let mm = Math.round(60 * (hours - hh));
  if (60 === mm) {
    hh += 1;
    mm = 0;
  }
  
  return hh.toString() + ':' + mm.toString().padStart(2, '0');
}



// WEBPACK FOOTER //
// ./src/helpers/formatHours.js